// Spanish alt text for the photos in asset/photos, keyed by photo id.
// English alt text lives next to the photos themselves.
const photoAlts = {
  goldenHour: 'Atados de canela de Ceilán sobre una tela al aire libre, al atardecer',
  gardenBundles: 'Atados de canela en rama de distintos grosores en un jardín',
  lawnBundles: 'Cuatro atados de canela en rama delgada sobre el pasto',
  gardenMixed: 'Atados de canela de varios grados sobre una mesa al aire libre',
  gardenCloseup: 'Vista cercana de atados de canela en rama con pasto al fondo',
  estateTree: 'Árbol joven de canela con hojas nuevas rojizas en la plantación',
  nurserySeedlings: 'Hileras de plántulas de canela en el vivero',
  nurseryPath: 'Plántulas de canela en macetas a lo largo de un camino del vivero',
  withLeaves: 'Atados de canela en rama acomodados con hojas frescas de canela',
  withLeavesSide: 'Cuatro atados de canela en rama con una rama de hojas de canela',
  fineQuills: 'Un atado apretado de canela en rama delgada y clara',
  crossSection: 'Extremo de ramas de canela que muestra muchas capas finas de corteza enrollada',
  quillEndsTop: 'Vista superior de un atado de canela que muestra los extremos enrollados',
  thickQuills: 'Un atado de canela en rama más ancha, amarrado con cordel',
  threeBundles: 'Tres atados de canela en rama de distintos largos y grosores',
  bundleEndsGroup: 'Cuatro atados de canela vistos desde el extremo, con sus capas enrolladas',
  estateTrees: 'Árboles maduros de canela en la plantación',
  peeling: 'Un pelador retirando la corteza de una rama de canela',
  grading: 'Trabajadoras clasificando ramas de canela en mesas largas',
};

export default photoAlts;
